import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SocialMedia from "../components/SocialMedia";
import PageBreak from "../components/PageBreak";

export default function UserLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <PageBreak />
      <SocialMedia />
      <PageBreak />
      <Footer />
    </>
  );
}
